import {
  TABLE_MANAGEMENT_SUBSCRIPTION_DISABLE_PAY_BUTTON,
  TABLE_MANAGEMENT_SUBSCRIPTION_ENABLE_PAY_BUTTON,
  TABLE_MANAGEMENT_SUBSCRIPTION_END_TUTORIAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE,
  TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS,
  TABLE_MANAGEMENT_SUBSCRIPTION_FINISH_LOADING_PAGE,
  TABLE_MANAGEMENT_SUBSCRIPTION_GET_BILLINGS,
  TABLE_MANAGEMENT_SUBSCRIPTION_GET_OUTLETS,
  TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_PAGE_REQUEST,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_OUTLETS,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
  TABLE_MANAGEMENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
  TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_START_TRIAL,
  TABLE_MANAGEMENT_SUBSCRIPTION_SUBSCRIPTION_STATUS,
  TABLE_MANAGEMENT_SUBSCRIPTION_VERIFY_BILLING
} from './constant'

// Default dispatch
export function pageRequest (trialEndAt, outletSlot, billingNotification, alreadySubscribed) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_PAGE_REQUEST,
    payload: {trialEndAt, outletSlot, billingNotification, alreadySubscribed}
  }
}

export function featurePricePerMonths () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS
  }
}

export function featurePrice (trialEndAt, outletSlot, alreadySubscribed) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_FEATURE_PRICE,
    payload: {trialEndAt, outletSlot, alreadySubscribed}
  }
}

export function subscriptionStatus () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SUBSCRIPTION_STATUS
  }
}

export function finishLoadingPage () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_FINISH_LOADING_PAGE
  }
}

export function endTutorial (featureName) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_END_TUTORIAL,
    payload: {featureName}
  }
}

export function verifyBilling (billingData) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_VERIFY_BILLING,
    payload: {billingData}
  }
}

export function startTrial () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_START_TRIAL
  }
}

// Setter
export function setIsOnTutorial (isOnTutorial) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
    payload: {isOnTutorial}
  }
}

export function setFeaturePricePerMonths (featurePricePerMonths) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
    payload: {featurePricePerMonths}
  }
}

export function setFeaturePrice (featurePrice) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_FEATURE_PRICE,
    payload: {featurePrice}
  }
}

export function setPendingPaymentMessage (pendingPaymentMessage) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
    payload: {pendingPaymentMessage}
  }
}

export function setPendingOutletMessage (pendingOutletMessage) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
    payload: {pendingOutletMessage}
  }
}

export function setSubscriptionDetail (subscriptionDetail) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
    payload: {subscriptionDetail}
  }
}

export function setCurrentOutletCount (currentOutletCount) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
    payload: {currentOutletCount}
  }
}

export function setOutlets (outlets) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_OUTLETS,
    payload: {outlets}
  }
}

export function setPayButtonMessage (buttonMessage) {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
    payload: {buttonMessage}
  }
}

// Getter
export function getBillings () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_GET_BILLINGS
  }
}

export function getOutlets () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_GET_OUTLETS
  }
}

// Other dispatch
export function enablePayButton () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_ENABLE_PAY_BUTTON
  }
}

export function disablePayButton () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_DISABLE_PAY_BUTTON
  }
}

export function showDetailTransactionModal () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL
  }
}

export function hideDetailTransactionModal () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL
  }
}

export function showPaymentGatewayErrorModal () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL
  }
}

export function hidePaymentGatewayErrorModal () {
  return {
    type: TABLE_MANAGEMENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL
  }
}



// WEBPACK FOOTER //
// ./app/actions/tableManagement/tableManagementSubscription/index.js